/**
 * Inventory Store
 *
 * @since 2018-08-28
 * @author Nanhyoung.Ro <dev014>
 */
import Moment from 'moment'

export const state = () => ({
  apiPreFix: '/api/lr',
  browserApi: '/monitor/log-browser',
  trendApi: '/trend',
  listApi: '/logs',
  backupApi: '/backup',
  restoreUrl: '/restore',
  diskCapacity: '/api/co/temp/disk/capacity', // 업로드 가능 상태 여부 체크
  // ===  onSearch ===
  search: {
    sdate: Moment().add(-1, 'week').format('YYYY-MM-DD'),
    edate: Moment().format('YYYY-MM-DD'),
    groupby: 'date'
  },
  defaultList: [],
  trendDefaultInfo: {
    bytes: 0,
    count: 0,
    trend: []
  },
  req_id: '',
  restore_req_id: ''
})

export const actions = {
  // 파일 업로드 가능 여부 체크 ( 용량 )
  async getDiskCapacity ({commit, state}, fileSize) {
    const {result, code} = await this.$axios.$get(`${state.diskCapacity}/${fileSize}`, {loading: false})
    if (code === 'ok' && result.upload_available === 1) {
      return true
    }
    return false
  },

  // 로그 브라우저 조회
  async getSearchResult ({commit, state}) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.browserApi}${state.listApi}`
    try {
      result = await this.$axios.$get(apiUrl, {params: state.search, loading: false})
      if (result.code === 'ok') {
        state.defaultList = result.result.log_list
      } else {
        state.defaultList = []
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      state.defaultList = []
      return result
    }
  },

  // 로그 브라우저 조회
  async getSearchTrend ({commit, state}) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.browserApi}${state.trendApi}`
    try {
      result = await this.$axios.$get(apiUrl, {params: { sdate: state.search.sdate, edate: state.search.edate }, loading: false})
      if (result.code === 'ok') {
        state.trendDefaultInfo = result.result
      } else {
        state.trendDefaultInfo = {
          bytes: 0,
          count: 0,
          trend: []
        }
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      state.trendDefaultInfo = {
        bytes: 0,
        count: 0,
        trend: []
      }
      return result
    }
  },

  // 로그 브라우저 삭제
  async removeBrowserInfo ({commit, state, store}, param) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.browserApi}${state.listApi}`
    try {
      result = await this.$axios.$delete(apiUrl, {data: {table_and_date_list: param}, loading: false, successAlert: false})
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      state.defaultList = []
      return result
    }
  },

  // 로그 백업 시작
  async startBackupFile ({commit, state}, param) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.browserApi}${state.backupApi}/start`
    try {
      result = await this.$axios.$post(apiUrl, param, {successAlert: false, loading: false})
      if (result.code === 'ok') {
        state.req_id = result.result.request_id
      } else {
        state.req_id = ''
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      state.req_id = ''
      return result
    }
  },
  // 로그 검색 진행 상태 조회
  async getBackupState ({commit, state, dispatch}) {
    if (state.req_id === undefined || state.req_id === '') {
      return {code: 'nok', reason: 'request_id is null'}
    }
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.browserApi}${state.backupApi}/${state.req_id}/status`
    try {
      result = await this.$axios.$get(apiUrl, {loading: false})
      if (result.code === 'ok') {
        if (result.result.status === 'DONE') {
          dispatch('downloadSave')
        }
      } else {
        dispatch('endFileSave')
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      dispatch('endFileSave')
      return result
    }
  },
  // 로그 파일 저장
  async downloadSave ({commit, state, dispatch, rootState}) {
    try {
      let apiUrl = `${state.apiPreFix}${state.browserApi}${state.backupApi}/${state.req_id}/save`

      // HA 부분 추가 (TAMS)
      const haApiPrefix = rootState.common.common.apiPrefix
      if (haApiPrefix.length > 1 && apiUrl.startsWith('/api/')) {
        apiUrl = apiUrl.replace('/api/', `${haApiPrefix}api/`)
      }

      const $iframe = $(`<iframe id="ifm-for-download" style='display: none' src='about:blank'></iframe>`).appendTo('body')
      const formDoc = $iframe[0].contentWindow.document

      formDoc.write(`<html><head></head><body><form method='GET' action='` + apiUrl + `'></form></body></html>`)
      const $form = $(formDoc).find('form')
      $form.submit()

      const checkFileDownloadComplete = () => {
        let cookieValue = 'true'
        if (typeof cookieValue === 'string') {
          cookieValue = cookieValue.toLowerCase()
        }

        const lowerCaseCookie = 'logbackup' + '=' + cookieValue
        if (document.cookie.toLowerCase().indexOf(lowerCaseCookie) > -1) {
          const cookieData = 'logbackup' + '=; path=' + '/' + '; expires=' + new Date(0).toUTCString() + ';'
          document.cookie = cookieData
          dispatch('endFileSave')
          formDoc.close()
          $iframe.remove()
          return
        }
        setTimeout(checkFileDownloadComplete, 100)
      }

      setTimeout(checkFileDownloadComplete, 100)
    } catch (e) {
      $('#ifm-for-download').remove()
    }
  },
  // 백업 끝!
  async endFileSave ({commit, state}) {
    let result = {}
    if (state.req_id === undefined || state.req_id === '') {
      result.code = 'nok'
      result.reason = 'request_id undefined'
      return result
    }
    const apiUrl = `${state.apiPreFix}${state.browserApi}${state.backupApi}/${state.req_id}/end`
    try {
      result = await this.$axios.$delete(apiUrl, {data: {request_id: state.req_id}, loading: false, successAlert: false, errorAlert: false})
      state.req_id = ''
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      return result
    }
  },

  // 로그 복원 시작
  async startRestoreFile ({commit, state}, fileName) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.browserApi}${state.restoreUrl}/start`
    try {
      result = await this.$axios.$post(apiUrl, fileName, {loading: false, successAlert: false})

      if (result.code !== 'ok') {
        result = {code: 'pok', errors: result.result.errors}
        return result
      } else {
        state.restore_req_id = result.result.request_id
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      return result
    }
  },
  // 로그 복원 진행 상태 조회
  async getRestoreState ({commit, state, dispatch}) {
    if (state.restore_req_id === undefined || state.restore_req_id === '') {
      return {code: 'nok', reason: 'request_id is null'}
    }
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.browserApi}${state.restoreUrl}/${state.restore_req_id}/status`
    try {
      result = await this.$axios.$get(apiUrl, {loading: false})
      if (result.code === 'ok') {
        if (result.result.status === 'DONE') {
          dispatch('endRestore')
          // dispatch('getSearchResult')
        }
      } else {
        dispatch('endRestore')
      }

      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      dispatch('endRestore')
      return result
    }
  },
  // 백업 끝!
  async endRestore ({commit, state}) {
    let result = {}
    if (state.restore_req_id === undefined || state.restore_req_id === '') {
      result.code = 'nok'
      result.reason = 'request_id undefined'
      return result
    }
    const apiUrl = `${state.apiPreFix}${state.browserApi}${state.restoreUrl}/${state.restore_req_id}/end`
    try {
      result = await this.$axios.$delete(apiUrl, {data: {request_id: state.restore_req_id}, loading: false, successAlert: false, errorAlert: false})
      state.restore_req_id = ''
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      return result
    }
  }
}

export const getters = {}
export const strict = false
